// eslint-disable-next-line import/no-unresolved

import axiosInstance from "./axios";

const isValidToken = (accessToken) => {
    if (!accessToken) {
        return false;
    }
    return true;
};

const setSession = (user) => {
    if (user) {
        axiosInstance.defaults.headers.companyid = user?.currentWorkshop?.company_id || user?.company_id;
        axiosInstance.defaults.headers.logincompanyid = user.company_id;
        axiosInstance.defaults.headers.userid = user.user_id;
        axiosInstance.defaults.headers.logintoken = user.web_token;
        axiosInstance.defaults.headers.timezone = user.timezone;
        // axiosInstance.defaults.headers.inventorymastercompanyid = user?.currentWorkshop?.inventory_master_company_inventory_master_idToinventory_master?.company_id;
        // axiosInstance.defaults.headers.inventorymasterid = user?.currentWorkshop?.inventory_master_company_inventory_master_idToinventory_master?.inventory_master_id;
    } else {
        delete axiosInstance.defaults.headers.companyid;
        delete axiosInstance.defaults.headers.logincompanyid;
        delete axiosInstance.defaults.headers.userid;
        delete axiosInstance.defaults.headers.logintoken;
        delete axiosInstance.defaults.headers.timezone;
        // delete axiosInstance.defaults.headers.inventorymastercompanyid;
        // delete axiosInstance.defaults.headers.inventorymasterid;
    }
};

const setTimezoneTypeHesetader = (currentTimezone) => {
    if (currentTimezone) {
        axiosInstance.defaults.headers.timezone = currentTimezone;
    } else {
        delete axiosInstance.defaults.headers.timezone;
    }
};
const setLanguage = (currentlanguage) => {
    if (currentlanguage) {
        axiosInstance.defaults.headers.common["Accept-Language"] = "en";
        axiosInstance.defaults.headers.language = currentlanguage;
    } else {
        delete axiosInstance.defaults.headers.language;
    }
};

export { isValidToken, setSession, setTimezoneTypeHesetader, setLanguage };
